import React, { useState } from "react";
import { useAdvSearch } from "../../providers/advSearchCtx";

function CustomSelect({ key, options, label, value }) {
  const { params, setParams } = useAdvSearch();

  const [open, setOpen] = useState(false);
  const onOpenHandler = (e) => {
    setOpen(!open);
  };
  const onSelectHandler = (e, value) => {
    e.preventDefault();
    setParams({ ...params, [key]: value });
    setOpen(false);
  };
  let this_label = "";
  if (value) {
    options.forEach((element) => {
      if (element.value === value) {
        this_label = element.label;
      }
    });
  } else {
    this_label = label;
  }
  return (
    <div className="flex-1-0">
      <div className="uk-inline">
        <button
          className="uk-button uk-button-default"
          type="button"
          onClick={onOpenHandler}
        >
          {this_label}
          {open && <span uk-icon="icon: chevron-up"></span>}
          {!open && <span uk-icon="icon: chevron-down"></span>}
        </button>
        {open && (
          <div className="uk-drop uk-dropdown uk-open">
            <ul className="uk-nav uk-dropdown-nav">
              {options.map((option) => (
                <li key={option.value}>
                  <a onClick={(e) => onSelectHandler(e, option.value)}>
                    {option.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

export default CustomSelect;
